import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { login, setToken, setUser } from '../services/auth';

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const data = await login(values.username, values.password);
      setToken(data.token);
      setUser(data.user);
      onLogin(data.user);
      message.success('登录成功');
      navigate('/');
    } catch (err) {
      message.error(err.response?.data?.error || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#f5f5f7',
      padding: 16,
    }}>
      <div style={{
        width: '100%',
        maxWidth: 400,
        background: 'rgba(255,255,255,0.72)',
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        borderRadius: 20,
        padding: '40px 32px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        <div style={{
          fontSize: 28,
          fontWeight: 700,
          color: '#1d1d1f',
          textAlign: 'center',
          marginBottom: 8,
          letterSpacing: -0.5,
        }}>
          欢迎回来
        </div>
        <div style={{
          fontSize: 15,
          color: '#86868b',
          textAlign: 'center',
          marginBottom: 32,
          fontWeight: 400,
        }}>
          登录你的账号以继续
        </div>
        <Form name="login" onFinish={onFinish} autoComplete="off" layout="vertical">
          <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input prefix={<UserOutlined style={{ color: '#86868b' }} />} placeholder="用户名" style={{ height: 48 }} />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined style={{ color: '#86868b' }} />} placeholder="密码" style={{ height: 48 }} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 16 }}>
            <Button type="primary" htmlType="submit" loading={loading} block style={{
              height: 48,
              fontSize: 16,
              fontWeight: 600,
              borderRadius: 12,
            }}>
              登录
            </Button>
          </Form.Item>
          <div style={{ textAlign: 'center', color: '#86868b', fontSize: 14 }}>
            还没有账号？<Link to="/register" style={{ color: '#007AFF', fontWeight: 500 }}>立即注册</Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;
